import React from 'react'
import moment from 'moment'
import map from 'lodash/map'
import ProductContainerSlot from './ProductContainerSlot'
import { findReplenishmentSlotActiveOrder, findProductReplenishmentName } from './shared'
import { ProductContainer, ReplenishmentOrder } from './types'

const LIQUID_CONTAINER_ROWS = 5
const LIQUID_CONTAINER_COLS = 6

const LIQUID_CONTAINER_SLOT_COUNT = LIQUID_CONTAINER_ROWS * LIQUID_CONTAINER_COLS

interface Props {
  searchQuery: string,
  currentProductCategoryId: number,
  containers: Record<number, ProductContainer>,
  currentDate: moment.Moment,
  expandContainer: Function,
  draftReplenishmentOrder: ReplenishmentOrder,
  activeReplenishmentOrders: ReplenishmentOrder[],
  replenishmentView?: boolean,
  disabledSlotNumbers?: number[],
  faultySlotNumbers?: number[]
}

const LiquidsView: React.FC<Props> = ({
  searchQuery, currentProductCategoryId, containers, currentDate, expandContainer,
  draftReplenishmentOrder, activeReplenishmentOrders, replenishmentView,
  disabledSlotNumbers, faultySlotNumbers
}) => {

  const slots = map(Array.from(Array(LIQUID_CONTAINER_SLOT_COUNT).keys()), slotIndex => {
    const slotNumber = slotIndex + 1

    return { slotNumber, container: containers[slotNumber] }
  })

  const hasDraftReplenishment = (slotNumber) => {
    return !!findReplenishmentSlotActiveOrder([draftReplenishmentOrder], 'liquid', slotNumber)
  }

  const hasSentReplenishment = (slotNumber) => {
    return !!findReplenishmentSlotActiveOrder(activeReplenishmentOrders, 'liquid', slotNumber)
  }

  const productReplenishmentName = (slotNumber) => {
    if(hasDraftReplenishment(slotNumber)) {
      return findProductReplenishmentName([draftReplenishmentOrder], 'liquid', slotNumber)
    } else if(hasSentReplenishment(slotNumber)) {
      return findProductReplenishmentName(activeReplenishmentOrders, 'liquid', slotNumber)
    }
    return null
  }

  return (
    <div className='tab-content liquids' style={{ gridTemplateColumns: `repeat(${LIQUID_CONTAINER_COLS}, 1fr)` }}>
      {map(slots, slot =>
        <ProductContainerSlot
          key={slot.slotNumber}
          slotNumber={slot.slotNumber}
          container={slot.container}
          currentDate={currentDate}
          expandContainer={expandContainer}
          searchQuery={searchQuery}
          currentProductCategoryId={currentProductCategoryId}
          isLiquid={true}
          replenishmentView={replenishmentView}
          hasDraftReplenishment={hasDraftReplenishment(slot.slotNumber)}
          hasSentReplenishment={hasSentReplenishment(slot.slotNumber)}
          productReplenishmentName={productReplenishmentName(slot.slotNumber)}
          isDisabled={disabledSlotNumbers?.includes(slot.slotNumber)}
          isFaulty={faultySlotNumbers?.includes(slot.slotNumber)}
        />
      )}
    </div>
  )
}

export default LiquidsView
